export const RoutesPaths = {
  Admin: {
    Login: '/admin/login',
    Home: '/admin/',
    Dashboard: '/admin/dashboard',
    User: '/admin/user',
    Calendar: '/admin/calendar',
    Questions: '/admin/questions',
    QuestionsDetails: '/admin/questions/edit',
    Typography: '/admin/typography',
    Icons: '/admin/icons',
    Notifications: '/admin/notifications',
    Services: '/admin/services',
    Admins: '/admin/admins',
    AddAdmin: '/admin/createAdmin',
    AdminDetails: '/admin/admins/edit',
    AdminProfile: '/admin/profile',
    Advisors: '/admin/advisors',
    AddAdvisor: '/admin/createAdvisor',
    AdvisersDetails: '/admin/advisors/edit',
    Clients: '/admin/clients',
    ClientProfileDetails: '/admin/clients/clientInfo',
    ClientDetailsView: '/admin/clients/clientView',
    ConsultantDetailsView: '/admin/consultants/consultantView',
    ConsultantVerificationsList: '/admin/consultantVerification',
    ConsultantVerificationForm: '/admin/consultantVerification/evaluation',
    ConsultantVerificationDetails: '/admin/consultantVerification/details',
    ClientDetails: '/admin/clients/clientDetails',
    AddConsultant: '/admin/consultants/addConsultant',
    AddBeneficiary: '/admin/clients/addBeneficiary',
    ConsultantsDetails: '/admin/consultants/consultantInfo',
    Consultants: '/admin/consultants',
    Projects: '/admin/projects',
    AddConsultantsToProject: '/admin/projects/addConsultants',
    AddBeneficiariesToProject: '/admin/projects/addBeneficiaries',
    ProjectDetails: '/admin/projects/projectDetails',
    AddProject: '/admin/projects/addProject',
    AddProjectSettings: '/admin/projects/solutionsForm',
    AddConsutlantsToProjectWizard: '/admin/projects/projectConsultantsList',
    AddBeneficiariesToProjectWizard: '/admin/projects/projectBeneficiariesList',
    ProjectConsultants: '/admin/projects/consutantsList',
    ProjectBeneficiaries: '/admin/projects/beneficiariesList',
    ProjectManagersList: '/admin/projectManagers',
    AddProjectManager: '/admin/projectManagers/add',
    ServiceDetails: '/admin/services/edit',
    Logout: '/admin/logout',
    PostQuestion: '/admin/questions/postQuestion',
    Evaluations: '/admin/viewEvaluations',
    ChangePassword: '/admin/changePassword',
    SubAccount: '/admin/subAccount',
  },
  App: {
    Login: '/login',
    Signup: '/signup',
    ForgetPassword: '/forgetPassword',
    ResetPassword: '/resetPassword',
    ChangePassword: '/changePassword',
    WelcomeAccount: '/welcomeAccount',
    Logout: '/logout',
    UserRegistrationForm: '/user/profile',
    ConsultantAdvancedRegistrationForm: '/user/profile/advanced',
    ConsultantFullRegistrationForm: '/user/profile/full',
    LandingPage: '/',
    ContactUs: '/contactUs',
    Solutions: '/solutions',
    Consultants: '/consultants',
    TermsAndConditions: '/terms',
    KnowHub: '/knowHub',
    Nformacy360: '/nformacy360',
    About: '/about',
    Dashboard: '/dashboard',
    Questions: '/questions',
    AnswerQuestion: '/question/answer',
    ServiceDetails: '/services/details',
    CallEvaluation: '/services/evaluation',
    MeetingWithAdmin: '/meetings/adminScheduler',
    EditServiceRequest: '/service/edit',
    NewQuestion: '/question/new',
    EditProfile: '/user/edit',
    AllNotifications: '/notifications',
    Services: '/services/list',
    ProjectDetails: '/projects/details',
    ActivitiesList: '/activities/list',
    ConsultantActivitiesList: '/consultant/activities',
    CorporateActivitiesList: '/corporate/activities',
    UserTypeSelection: '/user/type',
    EmailVerificationCallback: '/verifyEmail',
    EmailVerificationPending: '/verifyEmailPending',
    JitsiCall: '/jitsiCall',
    OauthSuccess: '/oauthCallback',
    NotFound: '/error',
    Accounts: '/accounts',
    AccountDetails: '/accounts/details',
    AddAccount: '/createAccount',
    Pointing: '/pointing',
  },
};
